import React, {PropTypes} from 'react';
import './price_adjustment.less';
import validate from '../../util/validate';

class NumberComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value : Math.round(this.props.price)
    }
  }
  componentDidMount(){
    this.setState({
      value : this.props.price,
      minPrice : this.props.minPrice
    })
  }
  inputChangeHandler = (e) =>{
    let value = parseFloat(e.target.value);
    if(validate.validAmount(value) && value >=this.props.minPrice){
      this.setState({
        value
      })
      this.props.changeHandler(this.props.for , value)
    }
  }
  componentWillReceiveProps(newProps){
    this.setState({
      value : Math.round(newProps.price),
      minPrice : newProps.minPrice
    })
  }
  render() {
    return (
      <div className = "number-component-wrap">
        <span className = "dollar-elem">$</span>
        <input type = "number" onChange = {this.inputChangeHandler}value = {this.state.value} className ="number-input-component"/>
      </div>
    )
  }
}


export default class PriceAdjustment extends React.Component {
  constructor(props) {
    super(props);
  }
  changePrice = (type) =>{
    let value,addedVal = parseFloat(this.props.price) + 1 ,subVal = parseFloat(this.props.price) - 1 ;
    if(validate.validAmount(addedVal) && type == "add" && addedVal >= this.props.minPrice)
    {
        value = parseFloat(addedVal.toFixed(1));
        this.props.changeHandler(this.props.for , value)
    }else if (subVal > -1 && type == "sub" && subVal >= this.props.minPrice){
        value = parseFloat(subVal.toFixed(1));
        this.props.changeHandler(this.props.for , value)
    }

  }
  render() {
    return (
      <div id= "price-adjustment-wrap">
        <div className = "substract-price">
          <div className ="add-sub-price" onClick = {() => this.changePrice("sub")}>-</div>
        </div>
        <div className = "calculated-price">
          <NumberComponent for ={this.props.for} price = {this.props.price} minPrice = {this.props.minPrice}changeHandler = {this.props.changeHandler} />
        </div>
        <div className = "add-price">
          <div className ="add-sub-price"onClick = {() => this.changePrice("add")}>+</div>
        </div>
      </div>
    )
  }
}

PriceAdjustment.propTypes = {
  price : React.PropTypes.number.isRequired,
  for : React.PropTypes.any.isRequired,                //unique id for the component e.g., state name in parent component
  changeHandler : React.PropTypes.func.isRequired     //returns for and new value for the component
};



// WEBPACK FOOTER //
// app/components/price_adjustment/price_adjustment.jsx